import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"

interface PageViewTrackingOptions {
  metadata?: Record<string, unknown>
  enabled?: boolean
}

export function usePageViewTracking(options: PageViewTrackingOptions = {}): void {
  const { metadata, enabled = true } = options
  const { pathname } = useLocation()
  const { mutate: addMemberAction } = useMemberActionTracking()
  const lastTrackedPathname = useRef<string | null>(null)
  const metadataRef = useRef(metadata)
  metadataRef.current = metadata

  useEffect(() => {
    if (!enabled) return
    if (pathname === lastTrackedPathname.current) return
    lastTrackedPathname.current = pathname
    addMemberAction({
      memberActionTaken: MemberActions.PAGE_VIEWED,
      metaData: { path: pathname, ...metadataRef.current }
    })
  }, [pathname, addMemberAction, enabled])
}
